import Abstract from "./abstract";

export default class QrCode extends Abstract {
  init() {
    this.getElement();

    this.updateElement();
  }

  getElement() {
    this.qrCodeElements = document.querySelectorAll(".js-qrcode");
  }

  updateElement() {
    const qrSize = Math.min(window.innerWidth, window.innerHeight) * 0.45;
    this.qrCodeElements.forEach((qrCodeElement) => {
      new QRCode(qrCodeElement, {
        text: qrCodeElement.dataset.url,
        width: qrSize,
        height: qrSize,
        correctLevel: QRCode.CorrectLevel.H,
      });
    });
  }
}
